@if (toast.message()) {
  <div class="toast">{{ toast.message() }}</div>
}
